import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  Box,
  Modal,
  Typography,
  Slider,
  Button,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  IconButton,
  useTheme,
} from "@mui/material";

import AudioRecorder from "../Archive/audioWrap/audioWrap";
import AudioPreview from "./AudioPreview";
import { Close } from "@mui/icons-material";
import CustomAudioPlayer from "../Archive/audioWrap/AudioPreview";
const CustomQuesItm = (props) => {
  console.log(props);
  const {
    label,
    value,
    onChange,
    isDisabled,
    title,
    options,
    fileAttributes,
    setFileAttributes,
    resetFormdata,
  } = props;
  console.log(fileAttributes, "file here is this");
  const [selectedOption, setSelectedOption] = useState("");
  //   const [files, setFiles] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [fontSize, setFontSize] = useState(16);
  const [showModal, setShowModal] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSliderChange = (event) => {
    setFontSize(event.target.value);
  };

  const modalClose = () => {
    setShowModal(false);
    setFontSize(16); // Reset font size when closing the modal
  };
  const handleLeftButtonClick = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 8));
  };

  const handleRightButtonClick = () => {
    setFontSize((prevSize) => Math.min(prevSize + 2, 40));
  };

  const handleRecordClick = () => {
    // Logic to handle recording
    console.log("Recording started");
  };
  const isFileValid = (file) => {
    const nameParts = file.name.split(".");
    const fileExt = nameParts[nameParts.length - 1];
    const fileType = file.type?.split("/")[0];
    return true;
  };

  const handleRedoClick = (pelm) => {
    setShowModal(true);
    setSelectedOption(pelm);
  };

  //   const handleDiscard = () => {
  //     fileAttributes[title] = null;
  //     console.log(fileAttributes);
  //   };
  const handleChange = (inpFiles) => {
    // change the file name, add the question id to it.
    const updatedFile = new File(
      [inpFiles[0]],
      props.schema.properties[selectedOption]?.qid +
        "_" +
        inpFiles[0].name
    );
    // onChange(updatedFile.name);
    console.log(updatedFile);

    // form data getting
    setFileAttributes((prevState) => {
      prevState[`${title}_${selectedOption}`] = [updatedFile];
      return prevState;
    });
    setTimeout(() => {
      setShowModal(false);
    }, 2000);

    // console.log(
    //   fileAttributes,
    //   fileAttributes[`${title}_${selectedOption}`][0]
    // );
  };

  useEffect(() => {
    if (isMobile) {
      setFontSize(24);
    } else {
      setFontSize(36);
    }
  }, []);

  return (
    <div>
      <h2>{title}</h2>
      {Object.keys(props.schema.properties).map((pelm, pidx) => (
        <div>
          <Box>
            <Typography variant={isMobile ? "subtitle2" : "body1"}>
              {props.schema.properties[pelm]?.question}
            </Typography>
            <div style={{ display: "block", marginTop: "10px", marginBottom: '10px' }}>
              {fileAttributes[`${title}_${pelm}`] ? (
                <CustomAudioPlayer
                  audioFile={
                    fileAttributes[`${title}_${pelm}`][0]
                      ? URL.createObjectURL(
                          fileAttributes[`${title}_${pelm}`][0]
                        )
                      : ""
                  }
                  redoFunction={() => {
                    handleRedoClick(pelm);
                  }}
                  showSave={false}
                  showControl={true}
                  handleSave={"null"}
                  sliderColor={"success"}
                />
              ) : (
                <Button
                variant="contained" color="primary"
                onClick={() => {
                  handleRedoClick(pelm);
                }}
              >
                Start Recording
              </Button>
              )}
            </div>
          </Box>
        </div>
      ))}
      {showModal && (
        <Dialog
          open={showModal}
          maxWidth={isMobile ? "sm" : "md"}
          fullWidth
          PaperProps={{
            sx: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              p: isMobile ? "10px" : "20px", // Reduce padding for mobile screens
              backgroundColor: "#FFF",
              borderRadius: "4px",
            },
          }}
        >
          <DialogTitle>
            Q{props.schema.properties[selectedOption]?.qid}
            <IconButton
              aria-label="close"
              onClick={modalClose}
              sx={{
                position: "absolute",
                top: "8px",
                right: "8px",
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              m: isMobile ? "0px" : "16px",
              p: isMobile ? "10px" : "20px",
              width: "100%",
            }}
          >
            {" "}
            <Typography
              variant="body1"
              style={{
                fontSize: `${fontSize}px`,
                maxHeight: "200px",
                overflowY: "auto",
                marginBottom: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {props.schema.properties[selectedOption]?.question}
            </Typography>
            <Box
              display="flex"
              width="100%"
              paddingY={"30px"}
            >
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={handleLeftButtonClick}
                style={{
                  fontSize: `${16}px`,
                  width: "50%",
                  background: "#E9EDF1",
                  borderTopRightRadius: "0",
                  borderBottomRightRadius: "0",
                  color: "black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                A-
              </Button>
              <Button
                size="large"
                variant="contained"
                color="primary"
                onClick={handleRightButtonClick}
                style={{
                  fontSize: `${32}px`,
                  width: "50%",
                  background: "#E9EDF1",
                  borderTopLeftRadius: "0",
                  borderBottomLeftRadius: "0",
                  color: "black",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                A+
              </Button>
            </Box>
            <AudioRecorder
              handleChange={handleChange}
              audioFile={
                fileAttributes[`${title}_${selectedOption}`]?.lenght
                  ? fileAttributes[`${title}_${selectedOption}`][0]
                  : null
              }
              sx={{ mt: isMobile ? "10px" : "16px" }}
            />{" "}
            {/* Reduce margin-top for mobile screens */}
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default CustomQuesItm;
